(() => {
  'use strict';
  Drupal.behaviors.customValidity = {
    attach: (context, settings) => {
      const translations = settings.wlcTranslations || {};

      function setCustomValidity(elements) {
        elements.forEach((element) => {
          element.oninvalid = function (e) {
            e.target.setCustomValidity('');
            let message = '';

            if (e.target.validity.valueMissing) {
              message =
                translations['Please fill out this field.'] ||
                'Please fill out this field.';
            } else if (e.target.id === 'postalCode') {
              message =
                translations['Please enter 5 digits, for example 34000'] ||
                'Please enter 5 digits, for example 34000';
            } else if (e.target.id === 'emailMessage') {
              message =
                translations[
                  'The email address must include an "@" and a valid domain name (for example: email@domain.com)'
                ] ||
                'The email address must include an "@" and a valid domain name (for example: email@domain.com)';
            }

            e.target.setCustomValidity(message);
          };

          element.oninput = function (e) {
            e.target.setCustomValidity('');
          };
        });
      }

      const postalCodeElement = document.getElementById('postalCode');
      if (postalCodeElement) {
        setCustomValidity([postalCodeElement]);
      }

      const emailElement = document.getElementById('emailMessage');
      if (emailElement) {
        setCustomValidity([emailElement]);
      }

      const elements = document.querySelectorAll('.js-custom-validity');
      if (elements.length !== 0) {
        setCustomValidity(elements);
      }
    },
  };
})();
